'use strict';

angular.module('adminEmailTemplatesControllers', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'services.adminEmailTemplates'
]);

